import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { mainNav } from "../sidebar/navigation";
import { useDispatch, useSelector } from "react-redux";
import { setSubcategory } from "../actions";
import { Button, Modal } from "components";
import Sidebar from "../sidebar";
import useMobile from "../../../../../hooks/useMobile";
import "./index.scss";


export const MobileSidebar = ({ billing }) => {

	const isOpen = useSelector(({ nav }) => nav.mobile);
	const dispatch = useDispatch();
	const isMobile = useMobile();
	const { pathname } = useLocation();
	const bannerHeight = useSelector(({ nav }) => nav.bannerHeight);

	const [appealModal, showAppealModal] = useState(false);

	useEffect(() => {
		if(document.querySelector('.sidebar-mobile-container')) {
			document.querySelector('.sidebar-mobile-container').style.top = `${bannerHeight + 56}px`;
		}
		if(document.querySelector('.outside-mobile-clicker')) {
			document.querySelector('.outside-mobile-clicker').style.top = `${bannerHeight + 56}px`;
		}
	}, [bannerHeight, isMobile, isOpen])

	useEffect(() => {

		mainNav(pathname).map(({ url, name, children }) => {
			if (children && children.length) {
				if (url) {
					dispatch(setSubcategory(name));
				}
			}

			return null;
		})

	}, [pathname]);

	return <>

		{isMobile ? <div className={`sidebar-mobile-container ${isOpen ? "open" : ""}`}>
			<Sidebar billing={billing} isMobile />
		</div> : null}


		<Modal open={appealModal} closeModal={() => showAppealModal(false)}>

			<div className="paylixecommerce-modal-header">
				Appeal feature not available
			</div>
			<div className="paylixecommerce-modal-body">
				<p style={{lineHeight: 1.5}}>
					Only Pro and Business users can appeal to feedback. <br/>
					The appeal feature has been restricted to the Pro and Business subscriptions. Please upgrade your
					account in order to be able to appeal any of your feedback.
				</p>
			</div>
			<div className="paylixecommerce-modal-footer">
				<Button onClick={() => showAppealModal(false)}>Close</Button>
				<Link to="/subscription" target="_blank">
					<Button>Pricing</Button>
				</Link>
			</div>

		</Modal>
	</>
}

export default MobileSidebar;
